import { render } from "./CancelOrder.vue?vue&type=template&id=1faea97b&scoped=true"
import script from "./CancelOrder.vue?vue&type=script&lang=js"
export * from "./CancelOrder.vue?vue&type=script&lang=js"

import "./CancelOrder.vue?vue&type=style&index=0&id=1faea97b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faea97b"]])

export default __exports__